import { render, staticRenderFns } from "./FeatureProMiniweb.vue?vue&type=template&id=42b75bf6&"
import script from "./FeatureProMiniweb.vue?vue&type=script&lang=js&"
export * from "./FeatureProMiniweb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports